/**
 * @function makeCheckedRoles
 * @param { array } roles
 * @param { string } id
 * @returns { array }
 */
function makeCheckedRoles(roles, id) {
	const newRoles = Array.from(roles);

	const index = newRoles.findIndex((role) => role.id === id);

	if (newRoles[index].checked === true) {
		newRoles[index].checked = false;
	} else {
		newRoles[index].checked = true;
	}

	return newRoles;
}

export default makeCheckedRoles;
